angular.module("app").directive("colorindexpopup", () => {
  let link = (scope) => {
    scope.allData = {
      data: scope.colorList,
      index: scope.index,
    };

    scope.data = scope.allData.data[scope.allData.index];
    scope.colorRGBTitle = () => {
      if (scope.data.rgb !== null) {
        const rgb =
          scope.mode === "auto"
            ? scope.data.color.color.rgb.split(",")
            : scope.data.rgb.split(",");
        return `R ${rgb[0]} / G ${rgb[1]} / B ${rgb[2]}`;
      }
      return "";
    };

    scope.LeftButton = () => {
      let index = scope.allData.index;
      if (index > 0) {
        index--;
      }
      scope.allData.index = index;
      scope.data = scope.allData.data[index];
    };

    scope.RightButton = () => {
      try {
        let index = scope.allData.index;
        if (index < scope.allData.data.length - 1) {
          index++;
        }
        scope.allData.index = index;
        scope.data = scope.allData.data[index];
      } catch (e) {}
    };

    scope.closeClickHandler = () => {
      scope.toggleFunction(false);
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };
  };
  return {
    restrict: "E",
    templateUrl: "app/directives/colorIndexPopup/colorIndexPopupView.html",
    link: link,
    scope: {
      color: "=",
      toggleFunction: "=",
      colorList: "=",
      index: "=",
      mode: "=",
      brand: "=",
      year: "=",
      logo: "=",
    },
  };
});
